import React from 'react';
const links = ['Terms of Service', 'Privacy Policy', 'Refund Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-ink px-5 py-12 text-white" data-id="element-105" data-mp="3ggaq1tbg494e">
      <div className="mx-auto max-w-5xl text-center" data-id="element-106" data-mp="32nuh6bvv5gvk">
        <p className="font-display text-2xl font-black uppercase tracking-tight" data-id="element-107" data-mp="32pfgsfx1bq0a">
          CAREER <span className="text-sun" data-id="element-108" data-mp="36q953aee36tp">READY™</span>
        </p>
        <nav aria-label="Footer" data-id="element-109" data-mp="3ufa64ckw7foy">
          
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-white/50" data-id="element-110" data-mp="3uftkjjbc3ly8">
          © 2026 CAREER READY™. All rights reserved.
        </p>
      </div>
    </footer>;
}